const OneDriveIcon = () => {
  return (
    <svg
      width='28'
      height='20'
      viewBox='0 0 24 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_875_24571)'>
        <path
          d='M9.1473 4.81951L14.1869 7.81797L17.1898 6.56209C17.8002 6.30014 18.4582 6.16544 19.123 6.16632C19.234 6.16632 19.3436 6.17153 19.4523 6.17824C19.0914 4.77945 18.3294 3.51493 17.2587 2.5384C16.188 1.56187 14.8549 0.915375 13.4214 0.677506C11.9878 0.439636 10.5156 0.620632 9.18364 1.19849C7.8517 1.77636 6.71738 2.7262 5.91858 3.93256L5.9951 3.93033C7.10873 3.92888 8.20057 4.23687 9.1473 4.81951Z'
          fill='#0364B8'
        />
        <path
          d='M9.14815 4.81886C8.20113 4.23635 7.10901 3.92862 5.9952 3.93043L5.91868 3.93266C4.82869 3.94621 3.76302 4.25457 2.83616 4.82463C1.90929 5.39468 1.15628 6.20487 0.658014 7.16815C0.15975 8.13143 -0.0649302 9.21139 0.00811461 10.292C0.0811594 11.3726 0.449168 12.413 1.0726 13.3015L5.51509 11.4434L7.49103 10.6175L11.8893 8.77805L14.1863 7.81807L9.14815 4.81886Z'
          fill='#0078D4'
        />
        <path
          d='M19.4524 6.17843C19.3428 6.17081 19.233 6.16684 19.1231 6.16651C18.4585 6.16597 17.8007 6.30092 17.1907 6.56302L14.187 7.81816L15.058 8.33616L17.9123 10.0348L19.1576 10.7756L23.4163 13.3097C23.8033 12.5961 24.0038 11.7974 23.9996 10.9868C23.9953 10.1762 23.7864 9.37957 23.392 8.66997C22.9975 7.96037 22.4302 7.36044 21.7419 6.92515C21.0537 6.48985 20.2665 6.23311 19.4524 6.17843Z'
          fill='#1490DF'
        />
        <path
          d='M19.1576 10.7756L17.9123 10.0347L15.0579 8.33537L14.1877 7.81812L11.89 8.7781L7.49173 10.6176L5.51504 11.4434L1.07104 13.3015C1.62341 14.0905 2.35978 14.7349 3.21726 15.1797C4.07474 15.6245 5.02784 15.8564 5.99514 15.8558H19.1231C20.0034 15.8561 20.8673 15.6195 21.6232 15.1713C22.3791 14.723 22.9987 14.0797 23.4163 13.3097L19.1576 10.7756Z'
          fill='#28A8EA'
        />
      </g>
      <defs>
        <clipPath id='clip0_875_24571'>
          <rect
            width='24'
            height='16'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default OneDriveIcon
